var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 0c3.31371 0 6 2.68629 6 6s-2.68629 6-6 6-6-2.68629-6-6 2.68629-6 6-6zm0 8c-.41421 0-.75.33579-.75.75s.33579.75.75.75.75-.33579.75-.75-.33579-.75-.75-.75zm0-5.5c-.24546 0-.44961.17688-.49194.41012l-.00806.08988v3.5l.00806.08988c.04233.23324.24648.41012.49194.41012s.44961-.17688.49194-.41012l.00806-.08988v-3.5l-.00806-.08988c-.04233-.23324-.24648-.41012-.49194-.41012z",
    fill: "#373f41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a7778b33ef41da148cac5569e255ec9f.svg";
export { ForwardRef as ReactComponent };